export const FAVORITE_LIST = [
	{
		code: 'FVRT01',
		name: '경제/시사',
		icon: '💰',
	},
	{
		code: 'FVRT02',
		name: '뷰티/패션',
		icon: '🛍',
	},
	{
		code: 'FVRT03',
		name: '여행/장소',
		icon: '️✈️',
	},
	{
		code: 'FVRT04',
		name: '요리/식품',
		icon: '🍳',
	},
	{
		code: 'FVRT05',
		name: '운동/건강',
		icon: '⚽',
	},
	{
		code: 'FVRT06',
		name: '육아/반려동물',
		icon: '🐶',
	},
	{
		code: 'FVRT07',
		name: '엔터/방송/밈',
		icon: '🎤',
	},
	{
		code: 'FVRT08',
		name: '전시/공연/도서',
		icon: '📚',
	},
	{
		code: 'FVRT09',
		name: '직장/자기개발',
		icon: '💻',
	},
	{
		code: 'FVRT10',
		name: '홈/리빙',
		icon: '🏠',
	},
	{
		code: 'FVRT11',
		name: '연애/결혼',
		icon: '💌',
	},
	{
		code: 'FVRT12',
		name: '인문/지식',
		icon: '💡',
	},
];

export type TSignupRequest = {
	nickname: string;
	optionalTerms: string[];
	gender?: '남자' | '여자';
	birthYear?: number;
	email?: string;
	favorites: string[];
	trafficSource:
		| {
				type: 'TFCSRC06';
				details: string;
		  }
		| {
				type: 'TFCSRC01' | 'TFCSRC02' | 'TFCSRC03' | 'TFCSRC04' | 'TFCSRC05';
		  }
		| undefined;
};

export interface TSignupResponse {
	status: 'ACTIVE';
	access: string;
	accessExpiresAt: string;
	refreshExpiresAt: string;
	userData: { uuid: string };
}
